import React from "react";
import {
  FiMonitor,
  FiServer,
  FiDatabase,
  FiCloud,
  FiTool,
} from "react-icons/fi";

const Skills: React.FC = () => {
  const skillCategories = [
    {
      title: "Desarrollo Frontend",
      icon: <FiMonitor className="w-8 h-8" />,
      skills: [
        "React",
        "TypeScript",
        "JavaScript",
        "HTML5",
        "CSS3",
        "Tailwind CSS",
        "Next.js",
        "Vue.js",
      ],
    },
    {
      title: "Desarrollo Backend",
      icon: <FiServer className="w-8 h-8" />,
      skills: ["Node.js", "Python", "Java", "Express.js", "REST APIs"],
    },
    {
      title: "Base de Datos",
      icon: <FiDatabase className="w-8 h-8" />,
      skills: [
        "PostgreSQL",
        "MySQL",
        "MongoDB",
        "Redis",
        "Firebase",
        "MariaDB",
      ],
    },
    {
      title: "DevOps & Cloud",
      icon: <FiCloud className="w-8 h-8" />,
      skills: ["AWS", "Azure", "Google Cloud", "Docker", "Kubernetes"],
    },
    {
      title: "Herramientas & Otros",
      icon: <FiTool className="w-8 h-8" />,
      skills: [
        "Git",
        "GitHub",
        "Figma",
        "VS Code",
        "Linux",
        "Agile/Scrum",
      ],
    },
  ];

  return (
    <section id="habilidades" className="py-16 md:py-20 bg-white">
      <div className="container px-4 mx-auto max-w-7xl">
        {/* Título principal */}
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
          Habilidades Técnicas
        </h2>

        {/* Grid de categorías */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {skillCategories.map((category, index) => (
            <div
              key={index}
              className="group bg-white border border-gray-100 p-6 rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-center mb-4">
                <div className="w-14 h-14 bg-primary-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0 text-primary-600 group-hover:bg-primary-600 group-hover:text-white transition-all duration-300">
                  {category.icon}
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-800">
                  {category.title}
                </h3>
              </div>

              <div className="flex flex-wrap gap-2">
                {category.skills.map((skill, skillIndex) => (
                  <span
                    key={skillIndex}
                    className="inline-block bg-primary-50 text-primary-700 px-3 py-1.5 rounded-full text-xs sm:text-sm font-medium hover:bg-primary-100 transition-colors duration-200 cursor-default"
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Niveles de Competencia */}
        <div className="mt-16 bg-gradient-to-r from-blue-50 to-indigo-50 p-6 md:p-8 rounded-2xl shadow-inner">
          <h3 className="text-2xl md:text-3xl font-bold text-center text-gray-800 mb-8">
            Niveles de Competencia
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {/* Expertas */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h4 className="font-bold text-lg text-gray-800 mb-5 flex items-center">
                <span className="w-3 h-3 bg-green-500 rounded-full mr-2"></span>
                Tecnologías Expertas
              </h4>
              <ul className="space-y-3">
                {[
                  "React & TypeScript",
                  "Docker & Kubernetes",
                  "Cloud Platforms (AWS/Azure)",
                ].map((item, i) => (
                  <li key={i} className="flex items-center text-gray-700">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3 flex-shrink-0"></div>
                    <span className="text-sm md:text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Intermedias */}
            <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100">
              <h4 className="font-bold text-lg text-gray-800 mb-5 flex items-center">
                <span className="w-3 h-3 bg-yellow-500 rounded-full mr-2"></span>
                Tecnologías Intermedias
              </h4>
              <ul className="space-y-3">
                {[
                  "Node.js & Express",
                  "Python & Django",
                  "Vue.js & Next.js",
                  "Microservicios",
                ].map((item, i) => (
                  <li key={i} className="flex items-center text-gray-700">
                    <div className="w-2 h-2 bg-yellow-500 rounded-full mr-3 flex-shrink-0"></div>
                    <span className="text-sm md:text-base">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;